(function($, SCS) {
	'use strict';

	// definitions
	var padding = 50; // total padding (left + right) -> will be subtracted when setting the width of the dialog
	var notificationWidth = 310;
	var dialogWidth = 470;

	var dialogStack = [];
	var currentDialog;

	function calculateWidth(options, element) {
		if(options.width && options.width !== 'auto') {
			return options.width;
		}
		if(element.is('.small')) {
			return notificationWidth - padding;
		}
		var isWideDialog = element.is('.wide') || element.find('img').length > 0;
		if(!isWideDialog) {
			for(var i in options.buttons) {
				if (i !== 'length') {
					// TODO: Describe why having a button named “length” matters…
					isWideDialog = true;
					break;
				}
			}
		}
		return (isWideDialog ? dialogWidth : notificationWidth) - padding;
	}

	// default settings
	$.ui.dialog.prototype.options.modal = true;
	$.ui.dialog.prototype.options.draggable = false;
	$.ui.dialog.prototype.options.resizable = false;
	$.ui.dialog.prototype.options.width = 'auto';
	$.ui.dialog.prototype.options.minHeight = false;
	$.ui.dialog.prototype.options.closeText = '';

	// recalculate position and apply -> provide a function that can be called like this: $(dom-element).dialog('reposition');
	$.ui.dialog.prototype.reposition = $.ui.dialog.prototype._position;

	// embed internal dialog-creation function to detect dom-element states before the dialog is created
	var originalDialogCreateFunction = $.ui.dialog.prototype._create;
	$.ui.dialog.prototype._create = function() {
		// set width of the dialog according to its type (design says
		// notifications (no buttons, no content-images) should have a with
		// of 300 pixels and dialogs (has buttons and/or images in content)
		// 460 pixels) -> this default-setting is overridable by setting a
		// width as option when creating the dialog
		// detect if the content element for the dialog is virtual or part of the dom (will be removed from dom after closing the dialog if it is virtual)
		this.options.width = calculateWidth(this.options, this.element);
		if (this.element.parent().length) {
			this.element.data('dialogOriginalClass', this.element.attr('class'));
			this.element.data('dialogOriginalStyle', this.element.attr('style'));
		} else {
			this.element.data('dialogRemoveFromDomAfterClose', true);
		}
		originalDialogCreateFunction.apply(this, arguments);
	};


	// embed internal dialog-opener function to connect the background-overlay to its corresponding dialog
	var originalDialogOpenFunction = $.ui.dialog.prototype.open;
	$.ui.dialog.prototype.open = function() {
		originalDialogOpenFunction.apply(this, arguments);
		this.overlay.data('myCorrespondingDialog', this.element);
		var $dialog = $(this.element);
		if (!$dialog.data('openedOnce')) {
			this.option('position', {my: 'center', at: 'center', of: window});
			SCS.utils.initNewModules(this.element);
			$dialog.on('changed.content', function() {
				$dialog.dialog('reposition');
			});
			$dialog.data('openedOnce', true);
		}
		// fix for jquery 1.11 incompatibility
		this.element.parent().find('button').each(function(){
			var button = $(this),
				labelText = button.attr('text');
			if(labelText){
				button.text(labelText);
			}
		});
		if (currentDialog) {
			dialogStack.push(currentDialog);
			currentDialog.uiDialog.hide();
			currentDialog.overlay.hide();
		}
		currentDialog = this;
	};

	$(function($) {
		// Add listeners to keep dialog centered on window resize and scroll
		$(document).on('dialogopen', function(event) {
			var $el = $(event.target);
			var $dialogContent = $('.ui-dialog-content', $el);
			// Add .no-center-on-scroll class to your .ui-dialog-content to prevent the dialog centering on window scroll.
			// Useful for longer dialog forms on iPad and similar cases.
			var events = ['resize', !$dialogContent.is('.no-center-on-scroll') && 'scroll'].filter(Boolean).join(' ');
			function reposition() {
				// center the dialog on the screen on scroll or window-resize
				$el.dialog('reposition');
			}
			$(window).on(events, reposition);
			$el.one('dialogclose', function() {
				$(window).off(events, reposition);
				currentDialog = undefined;
				if (dialogStack.length > 0) {
					currentDialog = dialogStack.pop();
					currentDialog.uiDialog.show();
					currentDialog.overlay.show();
					currentDialog.element.dialog('reposition');
				}
			});
		});


		$(document).on('dialogclose', function(event) {
			var el = $(event.target);
			if ((window.SCS && window.SCS.ecommerce) || !el.closest('.ui-dialog').is('.scs-pageheader-ui-dialog')) {
				// Prevent the rest of the close handler (which destroys the dialog) from runing
				return;
			}

			// destroy the dialog by default (normally the dialog is just hidden, but removed from the dom)
			el.dialog('destroy');
			// if the content element for the dialog was virtual (remove it from the dom) or part of the dom (restore its original classes and styles) before creating the dilaog
			if (el.data('dialogRemoveFromDomAfterClose')) {
				el.remove();
			} else {
				if (el.data('dialogOriginalClass') && el.data('dialogOriginalClass').length) {
					el.attr('class', el.data('dialogOriginalClass'));
				}
				if (el.data('dialogOriginalStyle') && el.data('dialogOriginalStyle').length) {
					el.attr('style', el.data('dialogOriginalStyle'));
				} else {
					el.removeAttr('style');
				}
			}

			el.trigger('dialogAfterClose');
		});

		// close the dialog if the corresponding background-overlay is clicked
		$(document).on('click', '.scs-pageheader-ui-dialog + .ui-widget-overlay', function() {
			if (!$(this).data('myCorrespondingDialog')) {
				return true;
			}
			$(this).data('myCorrespondingDialog').dialog('close');
		});

	});

})(window.$ || window.jQuery || window.scsHeaderJQuery, window.SCS);


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/dialog.js
// module id = 79
// module chunks = 0